import { productDataActions } from "./productdata-slice";

export const fetchProductData = () => {
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await fetch("../../json/product.json", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("couldn't fetch Product data");
      }
      const data = await response.json();
      return data;
    };
    const ProductData = await fetchData();
    dispatch(productDataActions.getProducts(ProductData.product));
  };
};
